import getters from './getters';
import actions from './actions';
import mutations from './mutations';

const state = () => ({
  customer: {
    user: false,
    cart: 0,
    cartItems: {},
    cartSuccess: false
  }
});

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};